import React from "react";
import Modal from "react-bootstrap/Modal";
import { internalReferralTypeLabels } from "../Constants";
import { ViewDateTime } from "../../../../utils/DateSupport";

const rowStyle = { display: "flex", padding: "6px 0", borderBottom: "1px solid #f0f0f0" };
const labelStyle = { width: "220px", color: "grey", flexShrink: 0 };
const valueStyle = { fontWeight: 500, wordBreak: "break-word" };

const DetailRow = ({ label, value }) => (
  <div style={rowStyle}>
    <span style={labelStyle}>{label}</span>
    <span style={valueStyle}>{value || "-"}</span>
  </div>
);

const capitalizeName = (name) =>
  name
    ? name.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
    : "-";

const InternalReferralDetailsModal = ({ modalShow, onHide }) => {
  const data = modalShow || {};
  const sourceEncounterId = data?.encounter?.reference?.split("/")?.[1];
  const targetEncounterId = data?.targetEncounter?.reference?.split("/")?.[1];

  return (
    <Modal
      backdropClassName
      backdrop={"static"}
      show={!!modalShow}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-dialog"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title id="contained-modal-title-vcenter">
          <span style={{ color: "grey", fontSize: "smaller" }}>Referrals&gt;</span>
          <span style={{ color: "#0064a6", fontSize: "smaller" }}>Internal Referral Details</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DetailRow label="Date/Time Created" value={ViewDateTime(data?.authoredOn || data?.updatedAt)} />
        <DetailRow label="Practitioner" value={capitalizeName(data?.practitionerName || data?.requester?.display)} />
        <DetailRow label="Patient" value={data?.subject?.display} />
        <DetailRow label="Source Encounter Id" value={sourceEncounterId} />
        {targetEncounterId ? (
          <DetailRow label="Referral Encounter Id" value={targetEncounterId} />
        ) : null}
        <DetailRow label="Service Line" value={data?.targetServiceLine?.display} />
        <DetailRow label="Referral Type" value={internalReferralTypeLabels[data?.referralType]} />
        <DetailRow label="Reason for Referral" value={data?.note?.text} />
      </Modal.Body>
    </Modal>
  );
};

export default InternalReferralDetailsModal;
